import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=926d2a8e&scoped=true&lang=pug&"
import script from "./Setup.vue?vue&type=script&lang=ts&"
export * from "./Setup.vue?vue&type=script&lang=ts&"
import style0 from "./Setup.vue?vue&type=style&index=0&id=926d2a8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926d2a8e",
  null
  
)

export default component.exports